import React, { useState, useEffect } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import clsx from "clsx";
import { useHistory } from "react-router-dom";

import { updateNotificationById } from "../../actions/notification-actions";

import useStyles from "../../styles/components/notification/stylesNotificationPopoverHolder";
import { setLearningContentSession, setLearningContentLevel, setTime } from "../../utils/helpers/others/SessionHelper";
import { News } from "../../utils/services/cache/ClientCache";

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

const NotificationPopoverHolder = ({ notification }) => {
    const classes = useStyles();
    const history = useHistory();
    const [title, setTitle] = useState("");
    const [group, setGroup] = useState("");

    useEffect(() => {
        if (notification.surveyVM !== null) {
            setGroup("New Survey");
            setTitle(notification.surveyVM.title);
        } else if (notification.newsVM !== null) {
            setGroup("New News");
            setTitle(notification.newsVM.title);
        } else if (notification.nonTraitLearningContentVM !== null) {
            setGroup("New Learning Content");
            setTitle(notification.nonTraitLearningContentVM.title);
        } else if (notification.recommendedLearningContentVM !== null) {
            setGroup("New Recommended Learning Content");
            setTitle(notification.recommendedLearningContentVM.title);
        }
        else if (notification.challengeVM !== null) {
            setGroup("Challenge");
            setTitle(notification.challengeVM.title);
        }
    }, []);

    const handleClick = async (e) => {
        e.preventDefault()
        await updateNotificationById(notification.id);

        if (notification.surveyVM !== null) {
            history.push("/Survey");
            history.go();
        } else if (notification.newsVM !== null) {
            News.setNewsId(notification.newsVM.newsId);
            history.push("/NewsDetail");
            history.go();
        } else if (notification.nonTraitLearningContentVM !== null) {
            const learningContent = {
                learningContentCategoryId: 0,
                learningContentCategoryName: "Non Trait Learning Contents",
                learningContentId: notification.nonTraitLearningContentVM.learningContentId,
                isAccessible: notification.nonTraitLearningContentVM.isAccessible,
                isCompleted: notification.nonTraitLearningContentVM.isCompleted,
                isRecommended: notification.nonTraitLearningContentVM.isRecommended,
            };
            setLearningContentSession(JSON.stringify(learningContent));
            setTime(new Date().getTime())
            history.push("/LearningContent");
            history.go();

        } else if (notification.recommendedLearningContentVM !== null) {
            setLearningContentLevel(notification.recommendedLearningContentVM.levelText > 0 ? notification.recommendedLearningContentVM.levelText : 0)
            const learningContent = {
                learningContentCategoryId: notification.recommendedLearningContentVM.traitGroupId,
                learningContentCategoryName: notification.recommendedLearningContentVM.traitGroupName,
                learningContentId: notification.recommendedLearningContentVM.learningContentId,
            };
            setLearningContentSession(JSON.stringify(learningContent));
            setTime(new Date().getTime())
            history.push("/LearningContent");
            history.go();
        }
        else if (notification.challengeVM !== null) {
            history.push(`/ChallengeDetail/${notification.challengeVM.challengeId}`);
            history.go();
        }

    };

    return (
        <div className={notification.isRead ? classes.rootItem : clsx(classes.rootItem, classes.rootItemRead)}>
            <ListItemLink
                onClick={handleClick}
                classes={{ root: classes.rootLink }} >
                <ListItemText primary={group} classes={{ primary: clsx(classes.rootItemGroup, !notification.isRead && classes.textGreen) }} />
                <ListItemText primary={title} classes={{ primary: clsx(classes.rootItemTitle, !notification.isRead && classes.textBold) }} />
            </ListItemLink>
        </div>
    );
};

export default NotificationPopoverHolder;